<div class="header" id="action-details-instance">
    <div class="wrapper">
        <div class="customerName">
            <div class="brandImage">
                <img src="assets/marriottLogo.png" class="brand-logo-image">
            </div>
            <div class="name">
                Springhill Suites (1,997 Locations)
            </div>
        </div>
        <div class="flex">
            <div class="year">For FY 2023</div>
            <mat-select id="action-status-select" placeholder="I want to...">
                <mat-option *ngIf="previousPage!=='Snoozed'">Snooze
                    <div class="line"></div>
                </mat-option>
                <mat-option *ngIf="previousPage=='Snoozed'">Unsnooze
                    <div class="line"></div>
                </mat-option>
                <mat-option *ngIf="previousPage!=='Dismissed'">Dismiss
                    <div class="line"></div>
                </mat-option>
                <mat-option *ngIf="previousPage!=='Completed' && previousPage!=='Recommended'">Mark as Complete
                    <div class="line"></div>
                </mat-option>
                <mat-option *ngIf="previousPage!=='My Actions'">Move to My Actions
                    <div class="line"></div>
                </mat-option>
                <mat-option id="presentation-add-option">Add to Presentation</mat-option>
            </mat-select>
        </div>
    </div>
</div>

<page-container class="flex justify-center">

    <div class="white-space"></div>
    <div class="white-space"></div>

    <div id="top-box">
        <div id="solution-header">
            <p id="solution-title">{{actionModel?.solution}}</p>

            <div id="flex-right">
                <!--Reverse order to employ row-reverse CSS-->
                <div id="customer-status-box">
                    <ng-template [ngIf]="actionModel!.recState.recommendationState !== 'My Actions'"
                        [ngIfElse]="myAction">
                        <div id="status">
                            {{actionModel?.recState?.recommendationStatus}}
                        </div>
                    </ng-template>
                    <ng-template #myAction>
                        <div class="status-select">
                            <mat-select id="customer-status-select"
                                [(ngModel)]="actionModel!.recState!.recommendationStatus" (ngModelChange)="setDates()">
                                <mat-option *ngFor="let status of recommendationStatusOptions" [value]="status">{{
                                    status }} <div class="line"></div></mat-option>
                            </mat-select>
                        </div>
                    </ng-template>

                    <div id="start-date">
                        <ng-template [ngIf]="actionModel!.recState!.startDate">
                            <ng-template [ngIf]="actionModel!.recState!.endDate" [ngIfElse]="startOnly">
                                {{actionModel!.recState!.startDate | date:'MM/dd/yyyy'}} -
                                {{actionModel!.recState!.endDate | date:'MM/dd/yyyy'}}
                            </ng-template>
                            <ng-template #startOnly>
                                {{actionModel!.recState!.startDate | date:'MM/dd/yyyy'}}
                            </ng-template>
                        </ng-template>
                    </div>
                </div>

                <div id="potential-opportunity-box">
                    <span class="box-header">${{actionModel?.groupedSalesOpportunity| number:'1.00':'en-US'}}</span>
                    <div id="potential-opportunity-line">
                        <p id='potential-opportunity' class="box-subheading">Potential Opportunity</p>
                        <div class="tooltip">
                            <img class='question-mark' src="assets/action-center-question-mark-button.svg">
                            <span class="tooltiptext">Potential opportunity based on average case prices.</span>
                        </div>
                    </div>
                </div>

                <div id="locations-box">
                    <span class="box-header">{{actionModel?.currentLocations?.length}}</span>
                    <p class="box-subheading">Locations</p>
                </div>
            </div>
        </div>
        <div id="solution-content">
            <img id='product-img' src="assets/placeholder-product.svg">
            <div id="product-description">
                <p id="pitch-title">{{actionModel?.sku}}</p>
                <p id="content">
                    {{actionModel?.solution}}
                </p>
                <div id="blue-text-row">
                    <img src="assets/action-center-view-product-details.svg">
                    <a id='solution-participation' class="blue-text" (click)="onClick()">
                        Solution Participation
                    </a>
                    <img class='chevron' src="assets/right-chevron.svg">
                </div>
                <ul class="custom-ul">
                    <!--for ones that aren't New Solution, just put in one of the reasons from the right here.-->
                    <li class="custom-li"><span>As of {{months[currDate.getMonth()]}} {{currDate.getFullYear()}},
                            {{actionProduct?.solution}}% of locations are ordering this product.</span></li>
                </ul>
            </div>
            <div id="product-why">
                <p id="why">Why?</p>
                <!--This is kinda whack but it works for rn-->
                <ul class="custom-ul" id="why-ul" style="margin:0;">
                    <!--We only want 4 lis first-->
                    <li class="custom-li">
                        <span>{{actionModel?.currentLocations![0].reasonSolution}}</span>
                    </li>
                    <li class="custom-li">
                        <span>{{actionModel?.currentLocations![1].reasonSolution}}</span>
                    </li>
                </ul>
                <!--On click of more details, display the rest AND change chevron-->
                <div id="more-details-row" class="flex" (click)="toggleChevron()">
                    <img [src]="imageSource" alt="Image" [class]="getImageClass()">
                    <span id='more-details' class="blue-text">
                        More Details
                    </span>
                </div>
                <div class="doughnut">
                    <div class="doughnut-container">
                        <div class="doughnut-wrapper">
                            <app-doughnut-chart
                                [colors]="[actionModel?.groupedDifficultyScale! <= 2 ? greenHex : orangeHex, grayHex]"
                                [data]="[actionModel?.groupedDifficultyScale!, 5 - actionModel?.groupedDifficultyScale!]"
                                [customMiddleText]="actionModel?.groupedDifficultyScale!.toString()"
                                [description]="'out of 5'"
                                [unique_id]="actionModel?.recId!">
                            </app-doughnut-chart>
                        </div>
                    </div>
                </div>
                <div id='difficulty-lvl' class="flex">
                    <p class="box-subheading center">Level of Difficulty</p>
                    <div class="tooltip">
                        <img class='question-mark' src="assets/action-center-question-mark-button.svg">
                        <span id="difficulty-tooltip" class="tooltiptext">Level of difficulty is based on a number of
                            factors:
                            <ul>
                                <li>Number of locations</li>
                                <li>Type of action</li>
                                <li>Estimated length of time</li>
                                <li>Amount of field engagement</li>
                            </ul>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="white-space"></div>
    <div class="white-space"></div>

    <div id="note-entry-box">
        <div id="notes-header">
            <p id="notes-title">New Note</p>
        </div>

        <div class="grow-wrap" style="width: 95%; margin-left: 2.5%; margin-top: 2vh;">
            <!-- Note: styling for textarea below does not apply when externalized. -->
            <textarea name="text" id="text" [(ngModel)]="this.noteBoxContents" placeholder="Leave a note here..."
                style="border: none;"></textarea>
        </div>

        <div id="notes-bottom-row">
            <div id="notes-icons">
                <img src="assets/text-icon.svg">
                <img src="assets/link-icon.svg">
                <img src="assets/paperclip-icon.svg">
            </div>
            <div id="notes-text">
                <p id='cancel' (click)='this.cancel()' class="gray-text">Cancel</p>
                <p id="notes-save" (click)="this.addActionNote()" class="blue-text">Save</p>
            </div>
        </div>
    </div>

    <div class="white-space"></div>

    <div id="note-read-box">
        <ng-container *ngFor="let month of noteBoxKeysObservable | async; let i = index">
            <div class="month" *ngIf="i < 2 || showAllMonths">
                <p id="date">{{ month }}</p>
                <ng-container *ngFor="let note of noteBoxDateMap.get(month)">
                    <div class="note">
                        <span class="note-heading">{{ note.noteContents }}</span>
                        <p class="note-time-date">{{ convertDate(note.noteDate) | noteTimeDate }}</p>
                    </div>
                </ng-container>
            </div>
        </ng-container>
        <img *ngIf="!hideLoadMore" id="load-more" src="assets/action-center-load-more.svg"
            (click)="showAllMonths = true; hideLoadMore = true;">
    </div>

    <div class="white-space"></div>
    <div class="white-space"></div>

    <div id="tvd">
        <div id='tvd-header'>Total Value Delievered Opportunity</div>
        <p id="tvd-value">+$20,123</p>
        <div class="grid-container">
            <div class="grid-item" *ngFor="let item of tvditems">
                <div class="left">
                    <img class="tvd-icon" src="{{ item.icon }}">
                    <p class="tvd-text">{{ item.text }}</p>
                </div>
                <div class="right">
                    <p class="cash-amt">{{ item.cashAmt }}</p>
                    <p class="unit-amt">{{ item.unitAmt }}</p>
                </div>
            </div>
        </div>
    </div>

    <div class="white-space"></div>
    <div class="white-space"></div>

    <!--Temporary item in which we should list linked materials-->
    <div id="hyperlinks">
        <div id="hyperlink-header">
            Hyperlinks:
        </div>
        <!--Bc this is temporary, placing style inline so it doesn't clog up scss file-->
        <ul style="margin-left: 1.5vw;">
            <li>
                <a href="https://www.google.com/">Google</a>
            </li>
            <li>
                <a href="https://www.bing.com/">Bing</a>
            </li>
            <li>
                <a href="https://www.ecolab.com/">Ecolab</a>
            </li>
        </ul>
    </div>

</page-container>
